/* eslint-disable no-unused-vars */
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { registerAuthModalOpener } from '../context/AuthContext'
import AuthModal from './AuthModal'
import ProfileSelector from './ProfileSelector'
import './Navbar.css'

function Navbar() {
    const { user, signOut } = useAuth()
    const [showAuth, setShowAuth] = useState(false)
    const [showMore, setShowMore] = useState(false)
    const location = useLocation()

    // Register opener so BrandCard and other components can trigger the modal
    useState(() => { registerAuthModalOpener(() => setShowAuth(true)) })

    const isActive = (path) => location.pathname === path
    const isMoreActive = ['/new', '/about', '/legal', '/listings'].includes(location.pathname)

    return (
        <>
            <nav className="navbar">
                <div className="navbar-left">
                    <Link to="/" className="navbar-logo">
                        marque<span>index</span>
                    </Link>
                </div>
                <div className="navbar-center">
                    <div className="navbar-links desktop-only">
                        <Link to="/" className={isActive('/') ? 'active' : ''}>Discover</Link>
                        <Link to="/brands" className={isActive('/brands') ? 'active' : ''}>All Brands</Link>
                        <Link to="/size-guide" className={isActive('/size-guide') ? 'active' : ''}>Size Guide</Link>
                        <Link to="/new" className={isActive('/new') ? 'active' : ''}>New</Link>
                        <Link to="/my-brands" className={isActive('/my-brands') ? 'active' : ''}>My Brands</Link>
                        <Link to="/listings" className={isActive('/listings') ? 'active' : ''}>Listings</Link>
                    </div>
                    {user && <ProfileSelector />}
                </div>
                <div className="navbar-right">
                    {user ? (
                        <>
                            <button className="btn-secondary desktop-only" onClick={signOut}>Sign out</button>
                            <button className="btn-secondary mobile-only mobile-signout" onClick={signOut}>Sign out</button>
                        </>
                    ) : (
                        <button className="btn-primary" onClick={() => setShowAuth(true)}>Sign in</button>
                    )}
                </div>
            </nav>

            <div className="mobile-bottom-nav mobile-only">
                <Link to="/" className={`mobile-tab ${isActive('/') ? 'active' : ''}`} onClick={() => setShowMore(false)}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                    <span>Discover</span>
                </Link>
                <Link to="/my-brands" className={`mobile-tab ${isActive('/my-brands') ? 'active' : ''}`} onClick={() => setShowMore(false)}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    <span>My Brands</span>
                </Link>
                <Link to="/brands" className={`mobile-tab ${isActive('/brands') ? 'active' : ''}`} onClick={() => setShowMore(false)}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                    <span>All Brands</span>
                </Link>
                <Link to="/size-guide" className={`mobile-tab ${isActive('/size-guide') ? 'active' : ''}`} onClick={() => setShowMore(false)}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 12h20M2 7h4m0 10h4M16 7h4m0 10h4"/></svg>
                    <span>Size Guide</span>
                </Link>
                <button className={`mobile-tab ${isMoreActive || showMore ? 'active' : ''}`} onClick={() => setShowMore(prev => !prev)} aria-label="More">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></svg>
                    <span>More</span>
                </button>
            </div>

            {showMore && (
                <>
                    <div className="more-backdrop mobile-only" onClick={() => setShowMore(false)} />
                    <div className="more-drawer mobile-only">
                        <Link to="/listings" className="more-drawer-item" onClick={() => setShowMore(false)}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                            Listings
                        </Link>
                        <Link to="/new" className="more-drawer-item" onClick={() => setShowMore(false)}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                            New Brands
                        </Link>
                        <Link to="/about" className="more-drawer-item" onClick={() => setShowMore(false)}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                            About
                        </Link>
                        <Link to="/legal" className="more-drawer-item" onClick={() => setShowMore(false)}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                            Privacy & Terms
                        </Link>
                    </div>
                </>
            )}

            {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
        </>
    )
}

export default Navbar
